import {
    JustpayPaymentMqttEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-paymentmqtt-endpoint-service"

// that relayed with /api/paymentmqtt
export class JustpayPaymentMqttService {
    constructor () {
        this.justpayPaymentMqttEndpointService = new JustpayPaymentMqttEndpointService()
    }

    // get configuration ID by point ID
    async getConf (pointId) {
        return this.justpayPaymentMqttEndpointService.getConf(pointId)
    }

    // get configuration ID by point ID for object pos
    async getConfPos (pointId) {
        return this.justpayPaymentMqttEndpointService.getConfPos(pointId)
    }

    async getConfiguration (configurationId) {
        return this.justpayPaymentMqttEndpointService.getConfiguration(configurationId)
    }

    async getEquipment (equipmentId) {
        return this.justpayPaymentMqttEndpointService.getEquipment(equipmentId)
    }

    async getSbpState (sbpId) {
        return this.justpayPaymentMqttEndpointService.getSbpState(sbpId)
    }

    //  the data is taken from server configuration
    async getTimeout () {
        return this.justpayPaymentMqttEndpointService.getTimeout()
    }

    // number: serial number of relay, relayIndex: index of relay, timeout: Time when relay will be ON, command:
    // 'JOGGING' or 'DELAY'
    async sendMessage (request) {
        console.log('mqttService sendMessage request', request)
        if (request.isRepeat) {
            request.relayRequests = request.relayRequests.map(item => {
                return {
                    number: item.number,
                    relayIndex: ++item.relayIndex,
                    timeout: item.timeout,
                    command: this._nameOfCommand(item.command),
                    // status: 'ON',
                    // ethernet: true,
                    // wifi: false,
                    operation: {
                        timeoutAfter: item.repeats.afterTimeout,
                        timeoutBefore: item.repeats.afterTimeout
                    }
                }
            })
        } else {
            request.relayRequests = request.relayRequests.map(item => {
                return {
                    number: item.number,
                    relayIndex: ++item.relayIndex,
                    timeout: item.timeout,
                    command: this._nameOfCommand(item.command),
                    operation: null
                }
            })
        }
        return this.justpayPaymentMqttEndpointService.sendMessage(request)
    }

    _nameOfCommand (command) {
        switch (command) {
            case 0:
                return 'ON'
            case 1:
                return 'JOGGING'
            case 2:
                return 'DELAY'
            case 3:
                return 'FLASH'
            case 4:
                return 'TOGGLE'
            default:
                return 'JOGGING'
        }
    }
}
